export function withTagProps(defaultValue: string) {
  return {
    /**
     * Tag komponentu
     */
    tag: {
      type: String,
      default: defaultValue
    }
  };
}

/**
 * Konfiguracja dla storybooka
 */
export function storiesTagArgs(defaultValue: string) {
  return {
    args: {
      tag: defaultValue
    },

    argTypes: {
      tag: {
        control: { type: 'text' }
      }
    }
  };
}
